import { ROUTE_PATH } from "../contants/routePath";
import BoundAdjustment from "../features/boundAdjustment/BoundAdjustment";
import Configuration from "../features/configuration/Configuration";
import NoAccess from "../features/noAccess/NoAccess";
import NotFound from "../features/notFound/NotFound";
import Permissions from "../features/permissions/Permissions";
import PlantManagement from "../features/plantManagement/PlantManagement";
import CustomLayout from "../layout/CustomLayout";
import Layout from "../layout/Layout";

const routerConfig = [
  {
    element: <Layout />,

    children: [
      {
        path: ROUTE_PATH.plantManagement,
        element: <PlantManagement />,
      },
      {
        element: <CustomLayout />,
        children: [
          {
            path: `plants/:id${ROUTE_PATH.configuration}`,
            element: <Configuration />,
          },
          {
            path: `plants/:id${ROUTE_PATH.permissions}`,
            element: <Permissions />,
          },
          {
            path: `plants/:id${ROUTE_PATH.boundAdjustment}`,
            element: <BoundAdjustment />,
          },
        ],
      },
    ],
  },
  {
    path: "no-access",
    element: <NoAccess />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
export default routerConfig;
